module.exports = __webpack_public_path__ + "static/media/figure17.d05268d5.png";